/**
 * Home Newsletter JS
 * To set Ajax to register email to the external system
 * And "visual effect"
 */
jQuery(document).ready(function(){

    jQuery("#loading").hide();

    jQuery("#newsletterForm").submit(function () {

        // Check if email is OK
        if (!IsEmail(jQuery('#email2').val())) {
            setNewsletterEmailTextInError(jQuery('#email2')) ;
            return false;
        }

        jQuery("#loading").show();
        var motcle = jQuery("#email2").val();
        var DATA = 'email=' + motcle;
        jQuery.ajax({
            type: "POST",
            url: jQuery("#newsletterForm").data("urlPost"),
            data: DATA,
            cache: false,
            complete: function () {
                jQuery("#loading").hide();
            },
            success: function () {
                setNewsletterEmailTextInSuccess(jQuery('#email2'));
            },
            error: function() {
                setNewsletterEmailTextInError(jQuery('#email2')) ;
            }
        });

        return false;
    });
});


